export default "__VITE_ASSET__2ddac0ab__"